import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import {
  HiGlobeAlt,
  HiDevicePhoneMobile,
  HiPaintBrush,
  HiServerStack,
  HiWrenchScrewdriver,
  HiChatBubbleLeftRight,
} from 'react-icons/hi2';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import PageHeader from '../Layout/PageHeader';
import gearArt from '../../assets/images/serv.png';
import 'swiper/css';
import 'swiper/css/pagination';
import '../../styles/services.css';

export const services = [
  {
    id: 1,
    name: 'Web Development',
    title: 'Full-Stack Web Development',
    description: 'Responsive, high-performance websites and web apps using React, Node.js, and modern tooling.',
    icon: HiGlobeAlt,
  },
  {
    id: 2,
    name: 'Mobile Development',
    title: 'Native Mobile Apps',
    description: 'Android and iOS applications built with Kotlin, Swift, and polished mobile UX patterns.',
    icon: HiDevicePhoneMobile,
  },
  {
    id: 3,
    name: 'UI / UX Design',
    title: 'Product Design',
    description: 'User-centered interfaces, design systems, and prototypes that balance beauty and usability.',
    icon: HiPaintBrush,
  },
  {
    id: 4,
    name: 'Backend & APIs',
    title: 'Scalable Backend Systems',
    description: 'REST APIs, cloud infrastructure, and data layers that power reliable digital products.',
    icon: HiServerStack,
  },
  {
    id: 5,
    name: 'Maintenance',
    title: 'Ongoing Support',
    description: 'Updates, monitoring, performance improvements, and long-term product evolution.',
    icon: HiWrenchScrewdriver,
  },
  {
    id: 6,
    name: 'Consulting',
    title: 'Technical Consulting',
    description: 'Architecture reviews, product strategy, and technology guidance for growing teams.',
    icon: HiChatBubbleLeftRight,
  },
];

const highlights = [
  { title: 'End-to-end delivery', text: 'From discovery and design to launch and support.' },
  { title: 'Dedicated team', text: 'Direct communication with the people building your product.' },
  { title: 'Modern stack', text: 'Proven technologies chosen for performance and maintainability.' },
];

const Services = () => {
  return (
    <main className="page page--services">
      <div className="services-showcase">
        <img src={gearArt} alt="" className="services-showcase__gears" aria-hidden="true" />
        <div className="page__inner">
          <PageHeader
            label="Services"
            title="What we do"
            description="From idea to launch — we help businesses design, build, and scale digital products."
          />

          <Swiper
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 24 },
              1100: { slidesPerView: 3, spaceBetween: 24 },
            }}
            modules={[Pagination]}
            className="services-swiper"
          >
            {services.map(({ id, name, title, description, icon: Icon }) => (
              <SwiperSlide key={id}>
                <article className="service-card service-card--geared surface-card">
                  <div className="service-card__icon" aria-hidden="true">
                    <Icon />
                  </div>
                  <span className="service-card__tag">{name}</span>
                  <h3 className="service-card__title">{title}</h3>
                  <p className="service-card__text">{description}</p>
                  <Link to={`/contact?service=${encodeURIComponent(title)}`} className="text-link">
                    Request a quote <FaArrowRight />
                  </Link>
                  <img src={gearArt} alt="" className="service-card__gear" aria-hidden="true" />
                </article>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="services-highlights">
            {highlights.map((item) => (
              <article key={item.title} className="services-highlights__item surface-card">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Services;
